import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import accountReducer from './accountReducer';
import notificationsReducer from './notificationsReducer';
import botsReducer from './botsReducer';
import chatReducer from './chatReducer';
import staffsReducer from './staffsReducer';
import totalStaffsReducer from './totalStaffsReducer';
import totalBotsReducer from './totalBotsReducer';
import customActionReducer from './customActionReducer';
import leadReducer from './leadReducer';
import analyticsReducer from './analyticsReducer';
import toasterReducer from './toasterReducer';
import llmCompletionConfigReducer from './llmCompletionConfigReducer';
import phoneNumbersReducer from './phoneNumbersReducer';
import agentReducer from './agentReducer';

const rootReducer = combineReducers({
  account: accountReducer,
  analytics: analyticsReducer,
  bots: botsReducer,
  notifications: notificationsReducer,
  chat: chatReducer,
  actions: customActionReducer,
  form: formReducer,
  leads: leadReducer,
  staffs: staffsReducer,
  totalStaffs: totalStaffsReducer,
  totalBots: totalBotsReducer,
  toaster: toasterReducer,
  phoneNumbers: phoneNumbersReducer,
  llmCompletionConfig: llmCompletionConfigReducer,
  agents: agentReducer
});

export default rootReducer;
